<script>
import FormElements from '@vvg/forum/js/mixins/formElements.js';
import Ajax from '@vvg/forum/js/mixins/ajax.js';
import {useForm} from "@inertiajs/vue3";

export default {
	name: "reactionForm",
	mixins: [FormElements, Ajax],
	props: {
		topicId: {
			type: Number,
			required: true
		},
		parentId: {
			type: Number,
			required: false,
			default: null
		},
		reaction: {
			type: Object,
			required: false,
			default: null
		}
	},
	emits: ['saved', 'cancel'],
	data() {
		return {
			form: useForm({
				id: this.reaction?.id ?? null,
				topic_id: this.topicId,
				parent_id: this.parentId,
				reaction: this.reaction?.reaction ?? '',
				user_id: this.$page.props?.auth?.user?.id ?? null,
			})
		}
	},
	computed: {
		isEdit() {
			return this.reaction !== null;
		},
		submitLabel() {
			if (this.isEdit) {
				return 'Opslaan';
			}
			if (this.parentId !== null) {
				return 'Reageren';
			}
			return 'Plaatsen';
		}
	},
	methods: {
		submit() {
			this.submitForm(this.$page.props.forum_url + 'save_reaction/', 'POST', this.form).done((response) => {
				this.showToast(this.isEdit ? 'Reactie bijgewerkt' : 'Reactie geplaatst');
				this.$emit('saved', response.reaction);
			});
		}
	}
}
</script>

<template>
  <form @submit.prevent="submit" class="reaction-form">
    <Textarea
        label="Reactie"
        v-model="form.reaction"
        name="reaction"
        :form="form"
        required
    />
    <div class="reaction-form__footer">
      <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          @click="$emit('cancel')"
      >
        Annuleren
      </button>
      <button
          type="submit"
          class="btn btn-dark btn-sm d-flex align-items-center gap-2"
      >
        <i class="fa fa-check"></i> {{ submitLabel }}
      </button>
    </div>
  </form>
</template>